import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  id: number;
  isHidden: boolean;
  isRead: boolean;
  updateCompletions: () => Promise<void>;
}

const MyTeamReviewMarkAsHidden = ({
  id,
  isHidden,
  isRead,
  updateCompletions
}: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { supervisor },
    supervisorUnreviewedItems,
    user
  } = useReduxState();

  const setHiddenStatus = async () => {
    if (!user) return false;

    await api.put(`/admin/supervisors/${user.id}/unreviewed-items/${id}`, {
      isHidden: !isHidden
    });
    await updateCompletions();

    if (!isRead) {
      const unreviewedItems = supervisorUnreviewedItems - 1;
      dispatch.setSupervisorUnreviewedItems(unreviewedItems);
      dispatch.updatePageState({
        supervisor: { ...supervisor, unreviewedItems }
      });
    }
    return true;
  };

  const labels = isHidden
    ? {
        confirmText: messages.myTeamReviewHideConfirmUnhide,
        icon: 'eye' as const,
        text: messages.commonUnhide
      }
    : {
        confirmText: messages.myTeamReviewHideConfirmHide,
        icon: 'eye-slash' as const,
        text: messages.commonHide
      };

  return (
    <ConfirmButton
      actionText={messages.commonConfirm}
      buttonIcon={labels.icon}
      buttonIsDropdown={true}
      buttonText={labels.text}
      confirmText={labels.confirmText}
      confirmTitle={labels.text}
      onConfirm={setHiddenStatus}
    />
  );
};

export default MyTeamReviewMarkAsHidden;
